import styled                   from 'styled-components';

import { CloseVector          } from 'src/components/vector/close';

import { DialogVariants       } from 'src/components/common/dialog';
import { ButtonVariants       } from 'src/components/common/button';
import { InputTextboxVariants } from 'src/components/common/input/input-textbox';
import { IconButtonVariants   } from 'src/components/common/icon-button';
import { TabSwitchVariants    } from 'src/components/common/tab-switch';
import { LabeledVariants      } from 'src/components/common/labeled';

import { cssFlexColumn,
         cssFlexRow,
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors          } from 'src/providers/theme/shared';



type DefectCalcDialogLookAndFeel = {
  paddings: number[];
  height: number;

  captionTypo: Typo;
  captionColor: string;

  gap: number;

  resultTypo: Typo;
  resultLabelColor: string;
  resultValueColor: string;

  buttonVariant: ButtonVariants;
  dialogVariant: DialogVariants;
  closeButtonVariant: IconButtonVariants;
  tabSwitchVariant: TabSwitchVariants;
  textboxVariant: InputTextboxVariants;
  labeledVariant: LabeledVariants;
}

const defectcalcdialog_light: DefectCalcDialogLookAndFeel = {
  paddings: [28, 20],
  height: 633,

  captionTypo: themeTypos.GRTSKREG_W400_S17_LH19,
  captionColor: themeColors.PrimaryBlack,

  gap: 24,

  resultTypo: themeTypos.GRTSKREG_W400_S16_LH20,
  resultLabelColor: themeColors.PrimaryBlack,
  resultValueColor: themeColors.AccentBlue2,

  buttonVariant: 'h48bluefill',
  dialogVariant: 'light',
  closeButtonVariant: 's48bluered',
  tabSwitchVariant: 'h32',
  textboxVariant: 'h48light',
  labeledVariant: 'light',
}

export type DefectCalcDialogVariants = 'light';

export const defectcalcdialog_variants: Map<DefectCalcDialogVariants, DefectCalcDialogLookAndFeel> = 
  new Map<DefectCalcDialogVariants, DefectCalcDialogLookAndFeel>([
    ['light', defectcalcdialog_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: DefectCalcDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap}px;
  height: ${(args) => args.lookAndFeel.height}px;
  position: relative;

  padding: ${(args) => args.lookAndFeel.paddings[0]}px ${(args) => args.lookAndFeel.paddings[1]}px;
`

export const Caption = styled.div<{
  lookAndFeel: DefectCalcDialogLookAndFeel
}>`
  text-align: center;

  ${(args) => typoAsCSS(args.lookAndFeel.captionTypo)};
  color: ${(args) => args.lookAndFeel.captionColor};
`

export const ResultContainer = styled.div<{
  lookAndFeel: DefectCalcDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap}px;
  flex-grow: 2;
  justify-content: flex-end;
`

export const Result = styled.div<{
  lookAndFeel: DefectCalcDialogLookAndFeel
}>`
  ${cssFlexRow};
  justify-content: space-between;

  ${(args) => typoAsCSS(args.lookAndFeel.resultTypo)};
`

export const ResultLabel = styled.div<{
  lookAndFeel: DefectCalcDialogLookAndFeel
}>`
  color: ${(args) => args.lookAndFeel.resultLabelColor};
`

export const ResultValue = styled.div<{
  lookAndFeel: DefectCalcDialogLookAndFeel
}>`
  color: ${(args) => args.lookAndFeel.resultValueColor};
`

export const Close = styled.div<{
  lookAndFeel: DefectCalcDialogLookAndFeel
}>`
  position: absolute;
  top: 0;
  right: 0;
`

export const CloseOutlineVectorBig = styled(CloseVector)`
  width: 16px;
  height: 16px;
`;
